import React from "react";
import { useEffect, useRef, useState } from "react";
import Posts from "./posts.jsx";
import { RelatedInsightsSlot } from "./post_pill.jsx";

const PostOne = () => {
    const showHelloWorld = true;
    const [postsType, setPostsType] = useState("");
    const [headings, setHeadings] = useState([]);
    const [activeHeadingKey, setActiveHeadingKey] = useState("");
    const postsWrapRef = useRef(null);

    useEffect(() => {
        const syncPostsType = (valueFromEvent) => {
            const value =
                typeof valueFromEvent === "string"
                    ? valueFromEvent
                    : localStorage.getItem("posts_type") || "";
            setPostsType(value);
        };

        const handlePostsTypeChange = (event) => {
            syncPostsType(event?.detail);
        };

        syncPostsType();
        window.addEventListener("posts-type-change", handlePostsTypeChange);

        return () => {
            window.removeEventListener("posts-type-change", handlePostsTypeChange);
        };
    }, []);

    useEffect(() => {
        if (!showHelloWorld || postsType !== "html") {
            setHeadings([]);
            setActiveHeadingKey("");
            return;
        }

        let rafId = 0;
        let timeoutId = 0;
        let attempts = 0;
        const maxAttempts = 24;

        const buildHeadings = () => {
            const root = postsWrapRef.current;
            if (!root) {
                if (attempts < maxAttempts) {
                    attempts += 1;
                    rafId = window.requestAnimationFrame(buildHeadings);
                }
                return;
            }
            const h2Nodes = root.querySelectorAll("article h2");
            if (h2Nodes.length === 0) {
                if (attempts < maxAttempts) {
                    attempts += 1;
                    rafId = window.requestAnimationFrame(buildHeadings);
                }
                return;
            }

            const next = [];
            h2Nodes.forEach((node, index) => {
                const text = (node.textContent || "").trim();
                if (!text) return;
                const key = `h2-${index}-${text}`;
                next.push({ key, text, index });
            });

            setHeadings(next);
            setActiveHeadingKey((prev) =>
                next.some((item) => item.key === prev) ? prev : ""
            );
        };

        buildHeadings();
        timeoutId = window.setTimeout(() => {
            buildHeadings();
        }, 900);

        return () => {
            window.cancelAnimationFrame(rafId);
            window.clearTimeout(timeoutId);
        };
    }, [showHelloWorld, postsType]);

    const scrollToHeading = (heading) => {
        const root = postsWrapRef.current;
        if (!root) return;
        const h2Nodes = root.querySelectorAll("article h2");
        const el = h2Nodes?.[heading.index];
        if (!el) return;
        setActiveHeadingKey(heading.key);

        const getScrollParent = (node) => {
            let parent = node.parentElement;
            while (parent) {
                const style = window.getComputedStyle(parent);
                const canScrollY =
                    /(auto|scroll|overlay)/.test(style.overflowY) &&
                    parent.scrollHeight > parent.clientHeight;
                if (canScrollY) return parent;
                parent = parent.parentElement;
            }
            return document.scrollingElement || document.documentElement;
        };

        const scrollParent = getScrollParent(el);
        if (
            scrollParent === document.documentElement ||
            scrollParent === document.body ||
            scrollParent === document.scrollingElement
        ) {
            const top = el.getBoundingClientRect().top + window.pageYOffset - 55;
            window.scrollTo({ top, behavior: "smooth" });
            return;
        }

        const parentRect = scrollParent.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();
        const top = scrollParent.scrollTop + (elRect.top - parentRect.top) - 20;
        scrollParent.scrollTo({ top, behavior: "smooth" });
    };

    return (
        showHelloWorld ? (
            <div className="px-3 py-2">
                <div className="mx-auto flex max-w-[1240px] flex-col gap-2 sm:gap-4 lg:flex-row lg:items-start">
                    <div className="w-full lg:w-72 lg:flex-none">
                        <div className="mt-6 max-sm:mt-2 rounded-2xl border border-blue-100/80 bg-blue-50/90 px-4 pb-4 pt-3 text-slate-700 shadow-sm backdrop-blur-md max-sm:pb-2 sm:pt-4">
                            <div className="max-lg:pt-1 lg:pt-4">
                                <div className="text-lg font-semibold text-slate-800 text-center whitespace-nowrap">
                                    Table of Contents
                                </div>

                                {postsType === "html" && headings.length > 0 ? (
                                    <div className="max-lg:mt-3 lg:mt-5 space-y-1.5 sm:mt-4">
                                        {headings.map((item) => (
                                            <button
                                                key={item.key}
                                                type="button"
                                                onClick={() => scrollToHeading(item)}
                                                className={`block w-full rounded-lg px-3 py-1.5 text-left text-sm font-medium transition sm:py-2 ${activeHeadingKey === item.key
                                                        ? "border-2 border-blue-400/90 bg-blue-300/65 text-black"
                                                        : "border border-blue-100/80 bg-blue-200/60 text-black hover:border-blue-400/90 hover:bg-blue-300/65"
                                                    }`}
                                            >
                                                {item.text}
                                            </button>
                                        ))}
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                        <RelatedInsightsSlot position="sidebar" className="max-lg:mt-1 lg:mt-5" />
                    </div>
                    <div ref={postsWrapRef} className="min-w-0 flex-1">
                        <Posts embedded showHelpfulBox />
                        <RelatedInsightsSlot position="below" className="mt-2" />
                    </div>
                </div>
            </div>
        ) : (
            <Posts showHelpfulBox />
        )
    );
};

export default PostOne;
